import React, { useState } from 'react';
import { 
  WxbButton, WxbCard, WxbBadge, WxbKpiCard, WxbInput, 
  WxbAlert, WxbStepper, WxbTableWrapper, WxbChartCard,
  WxbTopNav, WxbIcon, WxbLogo, WxbSwitch, WxbModal,
  WxbPageShell, WxbPageHeader, WxbPageSection, WxbPageGrid,
  WxbAppLayout,
  WxbFilterBar, WxbToolbarActions, WxbSelectionSummary,
  WxbIconButton, WxbActionMenu, WxbStack, WxbInline,
  WxbHeading, WxbText, WxbCodeText, WxbRow, WxbCol, WxbResponsiveGrid,
  WxbCommandBar, WxbChoiceCardGroup, WxbContentSwitch,
  WxbEntityHeader, WxbInspectorPanel, WxbWorkQueue, WxbStatusLegend, WxbValidationList,
  WxbActivityFeed, WxbCalendar, WxbCalendarStrip, WxbRiskMatrix, WxbCapacityHeatmap,
  // ── 新增表单控件 ──
  WxbSelect, WxbDatePicker, WxbTimePicker, WxbInputNumber,
  WxbTextarea, WxbSearchInput, WxbCheckbox, WxbRadioGroup,
  WxbSlider, WxbUpload, WxbFormField, WxbForm, WxbFormGrid,
  WxbFormSection, WxbFormFooter, WxbValidationSummary, WxbModalForm, WxbDrawerForm,
  // ── 新增数据展示 ──
  WxbBulkActionBar, WxbDataTable, WxbTableActionCell, WxbTag, WxbTooltip, WxbPopover,
  WxbAvatar, WxbAvatarGroup, WxbDescriptions, WxbTimeline, WxbStatusBadge, WxbSeverityBadge,
  WxbStatistic, WxbMetricGrid,
  WxbList, WxbTree, WxbSkeleton, WxbEmpty, WxbDivider,
  // ── 新增导航 ──
  WxbTabs, WxbBreadcrumb, WxbPagination, WxbSegmented, WxbDropdown,
  // ── 新增反馈 ──
  WxbDrawer, WxbPopconfirm, WxbSpinner, WxbProgress, WxbResult, WxbPageState,
  wxbToast, wxbMessage, wxbNotification, WxbCollapse,
  // ── 数据可视化 ──
  WxbBarChart, WxbPieChart, WxbAreaChart, WxbMiniGantt,
  WxbGauge, WxbSparkline, WxbGanttChart,
} from '../components/wxb-ui';
import { WxbIconsData, WxbIconName } from '../components/wxb-ui/Icon/icons';
import './UiKitShowcasePage.css';

const MOCK_CHART_DATA = [
  {used:65, avail:64, label:'W14', date:'2026-04-07'},
  {used:67, avail:60, label:'W15', date:'2026-04-14'},
  {used:70, avail:55, label:'W16', date:'2026-04-21'},
  {used:67, avail:58, label:'W17', date:'2026-04-28'},
  {used:73, avail:48, label:'W18', date:'2026-05-05'},
  {used:77, avail:43, label:'W19', date:'2026-05-12'},
  {used:80, avail:38, label:'W20', date:'2026-05-19'},
  {used:83, avail:33, label:'W21', date:'2026-05-26'},
  {used:84, avail:31, label:'W22', date:'2026-06-02'},
  {used:86, avail:27, label:'W23', date:'2026-06-09'},
  {used:88, avail:23, label:'W24', date:'2026-06-16'},
];

interface UiKitBatchRow {
  key: string;
  id: string;
  product: string;
  status: string;
  progress: number;
}

const MOCK_TABLE_ROWS: UiKitBatchRow[] = [
  { key: '1', id: 'BAT-001', product: '贝伐珠单抗', status: '进行中', progress: 67 },
  { key: '2', id: 'BAT-002', product: '阿达木单抗', status: '已完成', progress: 100 },
  { key: '3', id: 'BAT-003', product: 'ADC-X01', status: '待排程', progress: 0 },
];

const UiKitShowcasePage: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showFormDrawer, setShowFormDrawer] = useState(false);
  const [p1Choice, setP1Choice] = useState('capacity');
  const [paginationPage, setPaginationPage] = useState(3);
  const [tableSelectedRowKeys, setTableSelectedRowKeys] = useState<React.Key[]>(['1']);

  // Gantt drag demo state
  const [ganttTasks, setGanttTasks] = useState([
    { id: 't1', label: '称量', groupId: 'g1-s1', start: 2, end: 10, color: '#5A93F0', progress: 100, windowStart: 0, windowEnd: 14, status: '已完成' },
    { id: 't2', label: '溶解', groupId: 'g1-s1', start: 10, end: 18, color: '#5A93F0', progress: 80, windowStart: 8, windowEnd: 22 },
    { id: 't3', label: '过滤', groupId: 'g1-s1', start: 20, end: 28, color: '#5A93F0', progress: 45, windowStart: 18, windowEnd: 32 },
    { id: 't4', label: '接种', groupId: 'g1-s2', start: 30, end: 36, color: '#1F6FEB', progress: 30 },
    { id: 't5', label: '培养', groupId: 'g1-s2', start: 36, end: 84, color: '#1F6FEB', progress: 10 },
    { id: 't6', label: '收获', groupId: 'g1-s2', start: 84, end: 96, color: '#1F6FEB' },
    { id: 't7', label: 'CIP清洗', groupId: 'g2-s1', start: 98, end: 106, color: '#2E9D6E', progress: 0, windowStart: 96, windowEnd: 110 },
    { id: 't8', label: '灌装', groupId: 'g2-s1', start: 108, end: 120, color: '#2E9D6E' },
    { id: 't9', label: '封口', groupId: 'g2-s1', start: 120, end: 130, color: '#2E9D6E' },
    { id: 't10', label: '外观检测', groupId: 'g3', start: 132, end: 140, color: '#E8B53C' },
    { id: 't11', label: '含量测定', groupId: 'g3', start: 140, end: 152, color: '#E8B53C' },
    { id: 't12', label: '无菌检测', groupId: 'g3', start: 152, end: 168, color: '#E8B53C' },
  ]);
  const [dragLog, setDragLog] = useState<string[]>([]);

  return (
    <div style={{ padding: 24, fontFamily: 'var(--wx-font-sans)', background: '#F5F8FB', minHeight: '100vh' }}>
      <h1 className="wxb-h2" style={{ marginBottom: 24 }}>WuXi Biologics UI Kit Showcase</h1>

      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>0. Page Layout</h2>
        <WxbPageShell size="full">
          <WxbPageHeader
            eyebrow="Production Workspace"
            title="生产计划工作台"
            description="页面布局组件提供标题区、吸顶工具栏、内容分区和响应式网格，适合列表、调度和运行业务页面。"
            meta={(
              <>
                <WxbTag color="blue">MFG8</WxbTag>
                <WxbTag color="green">GMP Live</WxbTag>
              </>
            )}
            actions={(
              <>
                <WxbButton variant="secondary">导入计划</WxbButton>
                <WxbButton>新建批次</WxbButton>
              </>
            )}
          />
          <WxbFilterBar
            search={{
              placeholder: '搜索批次 / 产品',
              width: 220,
            }}
            filters={(
              <>
                <WxbSelect
                  defaultValue="all"
                  style={{ width: 150 }}
                  options={[
                    { value: 'all', label: '状态：全部' },
                    { value: 'risk', label: '仅看风险' },
                  ]}
                />
              </>
            )}
            view={(
              <WxbSegmented
                size="sm"
                defaultValue="week"
                options={[
                  { label: '日', value: 'day' },
                  { label: '周', value: 'week' },
                  { label: '月', value: 'month' },
                ]}
              />
            )}
            selection={(
              <WxbSelectionSummary
                selectedCount={2}
                label="2 个已选批次"
                onClear={() => undefined}
              />
            )}
            resultCount={24}
            resultLabel="个批次"
            actions={(
              <WxbToolbarActions
                items={[
                  { key: 'refresh', label: '刷新' },
                  { key: 'export', label: '导出' },
                ]}
              />
            )}
          />
          <WxbPageGrid minItemWidth="220px">
            <WxbKpiCard title="待排程批次" value="12" trend="up" trendText="3 new" />
            <WxbKpiCard title="资源冲突" value="4" trend="down" trendText="2 resolved" />
            <WxbKpiCard title="本周产能" value="78" unit="%" trend="neutral" trendText="stable" />
          </WxbPageGrid>
          <WxbPageSection
            variant="framed"
            title="今日重点"
            description="用分区承载页面主任务，不把页面结构继续塞进普通卡片。"
            actions={<WxbButton variant="ghost" size="sm">查看全部</WxbButton>}
          >
            <WxbTableWrapper>
              <thead>
                <tr>
                  <th>批次</th>
                  <th>阶段</th>
                  <th>负责人</th>
                  <th>状态</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="mono-cell">BAT-2026-001</td>
                  <td>上游培养</td>
                  <td>张工</td>
                  <td><WxbTag color="green">运行中</WxbTag></td>
                </tr>
                <tr>
                  <td className="mono-cell">BAT-2026-002</td>
                  <td>纯化准备</td>
                  <td>李工</td>
                  <td><WxbTag color="amber">待确认</WxbTag></td>
                </tr>
              </tbody>
            </WxbTableWrapper>
          </WxbPageSection>
          <WxbPageSection
            variant="framed"
            title="P0 基础承接组件"
            description="新添加：补齐 Space / Typography / Result / Statistic / Message 这类业务页高频缺口，后续页面迁移优先审核这一组。"
            actions={<WxbStatusBadge label="新添加" tone="cyan" variant="outline" />}
          >
            <WxbPageGrid minItemWidth="260px">
              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Layout">Stack / Inline</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbText as="p" tone="muted" size="sm">
                    统一垂直和水平间距，替代业务页面里反复出现的 Space、flex gap 和临时 wrapper。
                  </WxbText>
                  <WxbStack gap="sm">
                    <WxbInline gap="sm">
                      <WxbTag color="blue">批次</WxbTag>
                      <WxbTag color="green">资源</WxbTag>
                      <WxbTag color="amber">风险</WxbTag>
                    </WxbInline>
                    <WxbInline gap="sm" justify="between" fullWidth className="uikit-p0-inline-demo">
                      <WxbText size="sm" weight="medium">已选 3 项</WxbText>
                      <WxbButton variant="secondary" size="sm">批量处理</WxbButton>
                    </WxbInline>
                  </WxbStack>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Typography">Text / Heading</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbStack gap="sm">
                    <WxbHeading level={3} meta="用于卡片、抽屉和表单分组标题">生产窗口确认</WxbHeading>
                    <WxbText as="p" tone="secondary">
                      文字层级统一走组件，不再在页面里散落字号、颜色和行高。
                    </WxbText>
                    <WxbInline gap="sm">
                      <WxbCodeText>BAT-2026-001</WxbCodeText>
                      <WxbText tone="success" size="sm" weight="semibold">已完成校验</WxbText>
                    </WxbInline>
                  </WxbStack>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Metric">Statistic / MetricGrid</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbMetricGrid columns="auto">
                    <WxbStatistic
                      label="本周产能"
                      value="82"
                      unit="%"
                      tone="success"
                      trend={{ direction: 'up', label: '+4.5%' }}
                      description="较计划提升"
                    />
                    <WxbStatistic
                      label="冲突项"
                      value="5"
                      tone="warning"
                      trend={{ direction: 'down', label: '-2' }}
                      description="待复核"
                    />
                  </WxbMetricGrid>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="State">Result / PageState</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <div className="uikit-p0-state-grid">
                    <WxbResult
                      status="success"
                      size="sm"
                      title="提交成功"
                      description="计划已进入审核队列。"
                    />
                    <WxbPageState
                      status="error"
                      size="sm"
                      title="加载失败"
                      description="保留恢复动作和失败文案。"
                      onRetry={() => wxbMessage.info('重新加载计划状态')}
                    />
                  </div>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Feedback">Message Facade</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbText as="p" tone="muted" size="sm">
                    `wxbMessage` 作为 P0 消息入口，和既有 toast 样式保持一致，业务页不直接调用 antd message。
                  </WxbText>
                  <WxbInline gap="sm">
                    <WxbButton size="sm" onClick={() => wxbMessage.success('P0 消息入口可用')}>成功消息</WxbButton>
                    <WxbButton variant="secondary" size="sm" onClick={() => wxbMessage.warning('请复核资源冲突')}>预警消息</WxbButton>
                  </WxbInline>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Feedback">Notification</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbText as="p" tone="muted" size="sm">
                    `wxbNotification` 承接长文案、带动作的系统级反馈，避免业务页直接调用 antd notification。
                  </WxbText>
                  <WxbInline gap="sm">
                    <WxbButton
                      size="sm"
                      onClick={() => wxbNotification.success({
                        title: '批次窗口已锁定',
                        description: '审核通过后将同步到生产计划工作台。',
                      })}
                    >
                      成功通知
                    </WxbButton>
                    <WxbButton
                      variant="secondary"
                      size="sm"
                      onClick={() => wxbNotification.warning({
                        title: '资源冲突待复核',
                        description: 'USP-A 与 DSP-B 存在 30 分钟衔接风险。',
                        action: <WxbButton size="sm">查看</WxbButton>,
                      })}
                    >
                      带动作通知
                    </WxbButton>
                  </WxbInline>
                </WxbStack>
              </WxbCard>
            </WxbPageGrid>
          </WxbPageSection>

          <WxbPageSection
            variant="framed"
            title="P1 页面结构组件"
            description="新添加：补齐 Layout / Row / Col / CommandBar / RadioCard 这类页面骨架和操作模式，下一步迁移业务页面时优先替换它们。"
            actions={<WxbStatusBadge label="新添加" tone="cyan" variant="outline" />}
          >
            <WxbPageGrid minItemWidth="300px">
              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Layout">AppLayout</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbAppLayout
                    className="uikit-p1-app-preview"
                    density="compact"
                    navigation={<div className="uikit-p1-app-nav">MFG8 Shell</div>}
                    sidebar={(
                      <WxbStack gap="sm" className="uikit-p1-app-sidebar">
                        <WxbStatusBadge label="Planning" tone="info" />
                        <WxbStatusBadge label="Quality" tone="neutral" variant="outline" />
                      </WxbStack>
                    )}
                    footer="Footer / status rail"
                  >
                    <WxbStack gap="sm">
                      <WxbText weight="semibold">Content</WxbText>
                      <WxbResponsiveGrid minItemWidth="90px" gap="sm">
                        <div className="uikit-p1-mini-cell">KPI</div>
                        <div className="uikit-p1-mini-cell">Table</div>
                      </WxbResponsiveGrid>
                    </WxbStack>
                  </WxbAppLayout>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Grid">Row / Col</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbRow gap="sm">
                    <WxbCol span={7} tabletSpan={12}>
                      <div className="uikit-p1-grid-cell">
                        <WxbText weight="semibold">主内容 7/12</WxbText>
                        <WxbText tone="muted" size="sm">工艺路径、排程主表、Gantt 主画布。</WxbText>
                      </div>
                    </WxbCol>
                    <WxbCol span={5} tabletSpan={12}>
                      <div className="uikit-p1-grid-cell">
                        <WxbText weight="semibold">侧栏 5/12</WxbText>
                        <WxbText tone="muted" size="sm">筛选、诊断、冲突说明。</WxbText>
                      </div>
                    </WxbCol>
                    <WxbCol span={4} tabletSpan={4} mobileSpan={12}>
                      <div className="uikit-p1-grid-cell uikit-p1-grid-cell-muted">资源</div>
                    </WxbCol>
                    <WxbCol span={4} tabletSpan={4} mobileSpan={12}>
                      <div className="uikit-p1-grid-cell uikit-p1-grid-cell-muted">人员</div>
                    </WxbCol>
                    <WxbCol span={4} tabletSpan={4} mobileSpan={12}>
                      <div className="uikit-p1-grid-cell uikit-p1-grid-cell-muted">质量</div>
                    </WxbCol>
                  </WxbRow>
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Actions">CommandBar</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbCommandBar
                    density="compact"
                    leading={<WxbIcon name="kanban" size={22} />}
                    title="批次窗口操作"
                    description="集中承载主动作、次动作和当前状态。"
                    meta={<WxbStatusBadge status="running" size="sm" />}
                    secondaryActions={[
                      { key: 'draft', label: '保存草稿', onClick: () => wxbMessage.info('已保存草稿') },
                      { key: 'export', label: '导出', onClick: () => wxbMessage.info('导出已加入队列') },
                    ]}
                    primaryActions={[
                      { key: 'submit', label: '提交审核', onClick: () => wxbMessage.success('已提交审核') },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Choice">ChoiceCardGroup</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbChoiceCardGroup
                    value={p1Choice}
                    onChange={setP1Choice}
                    columns="auto"
                    options={[
                      {
                        value: 'capacity',
                        label: '产能优先',
                        description: '优先压低套间空闲时间。',
                        icon: 'bioreactor',
                        badge: <WxbStatusBadge label="推荐" tone="success" size="sm" />,
                      },
                      {
                        value: 'quality',
                        label: '质量优先',
                        description: '优先满足放行与复核窗口。',
                        icon: 'review-ok',
                      },
                      {
                        value: 'risk',
                        label: '风险优先',
                        description: '优先处理冲突和偏差项。',
                        icon: 'deviation',
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Views">ContentSwitch</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbContentSwitch
                    variant="tabs"
                    defaultActiveKey="overview"
                    items={[
                      {
                        key: 'overview',
                        label: '总览',
                        description: '用于同一对象下的轻量内容切换。',
                        children: (
                          <WxbMetricGrid columns="auto">
                            <WxbStatistic label="待处理" value="6" tone="warning" />
                            <WxbStatistic label="已完成" value="18" tone="success" />
                          </WxbMetricGrid>
                        ),
                      },
                      {
                        key: 'risk',
                        label: '风险',
                        badge: <WxbStatusBadge label="4" tone="warning" size="sm" />,
                        children: (
                          <WxbStack gap="sm">
                            <WxbStatusBadge label="套间窗口待复核" tone="warning" />
                            <WxbStatusBadge label="人员资质缺口" tone="error" variant="outline" />
                          </WxbStack>
                        ),
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>
            </WxbPageGrid>
          </WxbPageSection>

          <WxbPageSection
            variant="framed"
            title="P2 业务复合组件"
            description="新添加：补齐实体头、检查面板、任务队列和状态图例，用于替代业务页里重复拼装的 Card / List / Tag / Typography 组合。"
            actions={<WxbStatusBadge label="新添加" tone="cyan" variant="outline" />}
          >
            <WxbPageGrid minItemWidth="300px">
              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Entity">EntityHeader</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbEntityHeader
                    density="compact"
                    avatar={<WxbIcon name="batch-record" size={24} />}
                    eyebrow="Batch"
                    title="贝伐珠单抗 DS-01"
                    code="BAT-2026-001"
                    status={<WxbStatusBadge status="running" size="sm" />}
                    subtitle="上游培养窗口已确认，等待下游资源复核。"
                    meta={[
                      { key: 'suite', label: '套间', value: 'USP-A' },
                      { key: 'window', label: '窗口', value: '07/03 08:00' },
                      { key: 'owner', label: '负责人', value: '张工' },
                    ]}
                    actions={<WxbButton variant="secondary" size="sm">查看详情</WxbButton>}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Inspect">InspectorPanel</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbInspectorPanel
                    density="compact"
                    title="资源检查"
                    description="汇总放行、CIP、人员资质等关键门禁。"
                    status={<WxbSeverityBadge level="s2" size="sm" />}
                    sections={[
                      {
                        key: 'release',
                        title: '放行条件',
                        rows: [
                          { key: 'qc', label: 'QC 放行', value: '待复核', hint: '预计 16:30 前完成' },
                          { key: 'cip', label: 'CIP 状态', value: '已完成' },
                        ],
                      },
                      {
                        key: 'staff',
                        title: '人员准备',
                        rows: [
                          { key: 'lead', label: '班组长', value: '李工' },
                          { key: 'qualified', label: '资质覆盖', value: '7 / 8' },
                        ],
                      },
                    ]}
                    footer={<WxbButton size="sm">打开检查单</WxbButton>}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Queue">WorkQueue</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbWorkQueue
                    density="compact"
                    items={[
                      {
                        key: 'review',
                        icon: 'review-ok',
                        title: '复核批次窗口',
                        description: '确认 USP-A 与 DSP-B 的衔接时间。',
                        status: <WxbStatusBadge label="待处理" tone="warning" size="sm" />,
                        meta: ['计划员', '15 min'],
                        actions: <WxbButton variant="secondary" size="sm">处理</WxbButton>,
                      },
                      {
                        key: 'release',
                        icon: 'release',
                        title: '确认放行记录',
                        description: 'QC 附件已上传，等待 QA 签核。',
                        status: <WxbStatusBadge label="QA" tone="info" size="sm" />,
                        meta: ['质量', '高优先级'],
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Legend">StatusLegend</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbStatusLegend
                    orientation="vertical"
                    density="compact"
                    items={[
                      { key: 'running', label: '运行中', tone: 'info', count: '8', description: '正在执行的批次或任务' },
                      { key: 'released', label: '已放行', tone: 'success', count: '12', description: '质量门禁已通过' },
                      { key: 'warning', label: '需关注', tone: 'warning', count: '4', description: '窗口或资源待复核' },
                      { key: 'blocked', label: '阻断', tone: 'error', count: '1', description: '不可继续排程' },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Validation">ValidationList</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbValidationList
                    density="compact"
                    items={[
                      {
                        key: 'hold',
                        level: 'warning',
                        title: 'Hold time 接近上限',
                        description: 'DSP-B 开始时间建议提前 20 分钟。',
                        source: 'Rule H-02',
                        action: <WxbButton variant="secondary" size="sm">调整</WxbButton>,
                      },
                      {
                        key: 'release',
                        level: 'success',
                        title: 'QC 放行条件满足',
                        description: '批记录与放行附件已完成校验。',
                        source: 'QA',
                      },
                      {
                        key: 'staff',
                        level: 'error',
                        title: '夜班资质覆盖不足',
                        description: '缺少 1 名纯化操作资质人员。',
                        source: 'Roster',
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>
            </WxbPageGrid>
          </WxbPageSection>

          <WxbPageSection
            variant="framed"
            title="P3 高级运营组件"
            description="新添加：补齐活动流、月历、排程日历条、风险矩阵和产能热力图，用于承接 APS 页面里的运营诊断和计划可视化。"
            actions={<WxbStatusBadge label="新添加" tone="cyan" variant="outline" />}
          >
            <WxbPageGrid minItemWidth="320px">
              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Activity">ActivityFeed</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbActivityFeed
                    density="compact"
                    items={[
                      {
                        key: 'lock',
                        icon: 'review-ok',
                        tone: 'success',
                        title: '批次窗口已锁定',
                        description: 'BAT-2026-001 已通过计划复核。',
                        actor: '张工',
                        timestamp: '09:24',
                      },
                      {
                        key: 'risk',
                        icon: 'deviation',
                        tone: 'warning',
                        title: '资源冲突被标记',
                        description: 'DSP-B 与清场任务存在 30 分钟重叠。',
                        actor: '系统',
                        timestamp: '09:10',
                        actions: <WxbButton variant="secondary" size="sm">查看</WxbButton>,
                      },
                      {
                        key: 'release',
                        icon: 'release',
                        tone: 'info',
                        title: 'QA 上传放行附件',
                        description: '等待生产计划同步。',
                        actor: 'QA',
                        timestamp: '08:52',
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Calendar">Calendar</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbCalendar
                    density="compact"
                    defaultValue="2026-07-08"
                    defaultViewDate="2026-07-01"
                    maxEventRows={2}
                    minDate="2026-07-01"
                    maxDate="2026-07-31"
                    events={[
                      { key: 'seed', date: '2026-07-07', title: '接种', tone: 'info', meta: 'USP' },
                      { key: 'culture', date: '2026-07-08', title: '培养窗口', tone: 'warning', meta: '风险' },
                      { key: 'harvest', date: '2026-07-09', title: '收获', tone: 'cyan', meta: 'DSP' },
                      { key: 'release', date: '2026-07-10', title: 'QA 放行', tone: 'success' },
                      { key: 'cip', date: '2026-07-14', title: 'CIP', tone: 'neutral' },
                      { key: 'deviation', date: '2026-07-14', title: '偏差复核', tone: 'error' },
                    ]}
                    onSelect={(dateKey) => wxbMessage.info(`已选择 ${dateKey}`)}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Calendar">CalendarStrip</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbCalendarStrip
                    density="compact"
                    defaultSelectedKey="wed"
                    days={[
                      { key: 'mon', weekday: '周一', date: '06', label: '准备', events: [{ key: 'cip', label: 'CIP', tone: 'success' }] },
                      { key: 'tue', weekday: '周二', date: '07', label: '接种', events: [{ key: 'usp', label: 'USP-A', tone: 'info' }] },
                      { key: 'wed', weekday: '周三', date: '08', label: '培养', isToday: true, events: [{ key: 'risk', label: '窗口风险', tone: 'warning' }] },
                      { key: 'thu', weekday: '周四', date: '09', label: '收获', events: [{ key: 'dsp', label: 'DSP-B', tone: 'cyan' }] },
                      { key: 'fri', weekday: '周五', date: '10', label: '放行', events: [{ key: 'qa', label: 'QA', tone: 'success' }] },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Risk">RiskMatrix</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbRiskMatrix
                    likelihoodLabel="概率"
                    impactLabel="影响"
                    items={[
                      { key: 'hold', likelihood: 4, impact: 4, label: 'Hold', count: 2 },
                      { key: 'staff', likelihood: 3, impact: 5, label: '人员', count: 1 },
                      { key: 'cip', likelihood: 2, impact: 3, label: 'CIP', count: 3 },
                      { key: 'release', likelihood: 1, impact: 2, label: 'QA', count: 4 },
                    ]}
                  />
                </WxbStack>
              </WxbCard>

              <WxbCard>
                <WxbStack gap="lg" className="uikit-new-card">
                  <WxbInline justify="between" fullWidth>
                    <WxbHeading level={4} eyebrow="Capacity">CapacityHeatmap</WxbHeading>
                    <WxbStatusBadge label="新添加" tone="cyan" size="sm" />
                  </WxbInline>
                  <WxbCapacityHeatmap
                    density="compact"
                    columns={['D1', 'D2', 'D3', 'D4']}
                    rows={[
                      {
                        key: 'usp',
                        label: 'USP-A',
                        cells: [
                          { key: 'usp-d1', label: 'D1', value: '76%', level: 'normal' },
                          { key: 'usp-d2', label: 'D2', value: '88%', level: 'busy' },
                          { key: 'usp-d3', label: 'D3', value: '94%', level: 'busy' },
                          { key: 'usp-d4', label: 'D4', value: '62%', level: 'normal' },
                        ],
                      },
                      {
                        key: 'dsp',
                        label: 'DSP-B',
                        cells: [
                          { key: 'dsp-d1', label: 'D1', value: '48%', level: 'idle' },
                          { key: 'dsp-d2', label: 'D2', value: '82%', level: 'normal' },
                          { key: 'dsp-d3', label: 'D3', value: '106%', level: 'over', detail: '冲突' },
                          { key: 'dsp-d4', label: 'D4', value: '79%', level: 'normal' },
                        ],
                      },
                    ]}
                  />
                </WxbStack>
              </WxbCard>
            </WxbPageGrid>
          </WxbPageSection>

          <WxbPageSection
            variant="framed"
            title="第一阶段组件"
            description="补齐表单模式、状态语义和动作入口，用于替代页面里重复手写的状态、footer 和更多操作。"
          >
            <WxbPageGrid minItemWidth="280px">
              <WxbCard>
                <div className="uikit-phase-card">
                  <div>
                    <h3 className="uikit-phase-title">状态语义</h3>
                    <p className="uikit-phase-copy">把运行、放行、风险等级收敛到统一 tone，不在业务页面散落颜色判断。</p>
                  </div>
                  <div className="uikit-badge-row">
                    <WxbStatusBadge status="running" pulse />
                    <WxbStatusBadge status="released" />
                    <WxbStatusBadge status="unreleased" variant="outline" />
                    <WxbSeverityBadge level="s2" />
                    <WxbSeverityBadge level="s4" variant="outline" />
                  </div>
                </div>
              </WxbCard>

              <WxbCard>
                <WxbForm
                  gap="lg"
                  onSubmit={(event) => {
                    event.preventDefault();
                    wxbMessage.success('示例表单已提交');
                  }}
                >
                  <WxbValidationSummary
                    issues={[
                      { field: '批次窗口', message: '结束时间必须晚于开始时间' },
                      { field: '资源套间', message: '请选择已放行的生产套间' },
                    ]}
                  />
                  <WxbFormSection
                    title="批次基础信息"
                    description="FormSection + FormGrid 用于抽屉、弹窗和独立页面表单。"
                    density="compact"
                  >
                    <WxbFormGrid columns={2}>
                      <WxbInput label="批次号" defaultValue="BAT-2026-001" />
                      <WxbSelect
                        label="生产套间"
                        defaultValue="suite-a"
                        options={[
                          { value: 'suite-a', label: 'Suite A' },
                          { value: 'suite-b', label: 'Suite B' },
                        ]}
                      />
                    </WxbFormGrid>
                  </WxbFormSection>
                  <WxbFormFooter border>
                    <WxbButton type="button" variant="ghost">取消</WxbButton>
                    <WxbButton type="submit">保存草稿</WxbButton>
                  </WxbFormFooter>
                </WxbForm>
              </WxbCard>

              <WxbCard>
                <div className="uikit-phase-card">
                  <div>
                    <h3 className="uikit-phase-title">动作入口</h3>
                    <p className="uikit-phase-copy">IconButton 处理工具按钮，ActionMenu 处理二级和危险动作。</p>
                  </div>
                  <div className="uikit-action-row">
                    <WxbIconButton icon="inspect" label="查看详情" tooltip="查看详情" />
                    <WxbIconButton icon="review-ok" label="审核通过" tooltip="审核通过" variant="secondary" />
                    <WxbActionMenu
                      actions={[
                        { key: 'copy', label: '复制批次', icon: 'batch-record' },
                        { key: 'review', label: '提交复核', icon: 'review-ok' },
                        {
                          key: 'reject',
                          label: '驳回计划',
                          icon: 'rejected',
                          danger: true,
                          confirm: { title: '确认驳回该计划?', okText: '驳回' },
                        },
                      ]}
                    />
                  </div>
                  <div className="uikit-action-row">
                    <WxbButton variant="secondary" onClick={() => setShowFormModal(true)}>打开 ModalForm</WxbButton>
                    <WxbButton variant="secondary" onClick={() => setShowFormDrawer(true)}>打开 DrawerForm</WxbButton>
                  </div>
                </div>
              </WxbCard>
            </WxbPageGrid>
          </WxbPageSection>
        </WxbPageShell>

        <WxbModalForm
          title="新建批次"
          open={showFormModal}
          onCancel={() => setShowFormModal(false)}
          onSubmit={(event) => {
            event.preventDefault();
            setShowFormModal(false);
          }}
          footerExtra="保存后将进入待排程状态"
        >
          <WxbFormSection title="计划信息" density="compact">
            <WxbFormGrid columns={2}>
              <WxbInput label="批次号" placeholder="BAT-2026-001" />
              <WxbSelect
                label="产品"
                placeholder="请选择"
                options={[
                  { value: 'mab-a', label: '贝伐珠单抗' },
                  { value: 'mab-b', label: '阿达木单抗' },
                ]}
              />
            </WxbFormGrid>
          </WxbFormSection>
        </WxbModalForm>

        <WxbDrawerForm
          title="资源放行信息"
          open={showFormDrawer}
          width={460}
          onClose={() => setShowFormDrawer(false)}
          onSubmit={(event) => {
            event.preventDefault();
            setShowFormDrawer(false);
          }}
          footerExtra={<WxbStatusBadge status="unreleased" />}
        >
          <WxbValidationSummary issues={[{ field: 'QC 状态', message: '放行前必须完成质量确认' }]} />
          <WxbFormSection title="套间状态" density="compact">
            <WxbFormGrid columns={1}>
              <WxbInput label="套间" defaultValue="Suite A" />
              <WxbSelect
                label="QC 状态"
                defaultValue="pending"
                options={[
                  { value: 'pending', label: '待确认' },
                  { value: 'released', label: '已放行' },
                ]}
              />
              <WxbTextarea label="备注" rows={3} placeholder="补充放行说明" />
            </WxbFormGrid>
          </WxbFormSection>
        </WxbDrawerForm>
      </section>
      
      {/* 顶部导航展示 (纯 UI 组件) */}
      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>0. Global Navigation</h2>
        <WxbTopNav 
          links={[
            { id: '1', label: 'Overview', icon: <span style={{display:'inline-block', width:12, height:12, borderRadius:'50%', border:'2px solid currentColor'}}></span> },
            { id: '2', label: 'Operations', icon: <span style={{display:'inline-block', width:12, height:12, background:'currentColor'}}></span>, animClass: 'anim-cube' },
          ]}
          activeId="2"
        />
      </section>

      {/* 核心基础组件 */}
          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>1. Buttons & Inputs</h2>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
              <WxbButton variant="primary">Primary</WxbButton>
              <WxbButton variant="secondary">Secondary</WxbButton>
              <WxbButton variant="ghost">Ghost</WxbButton>
              <WxbButton variant="danger">Danger</WxbButton>
            </div>
            <div style={{ display: 'flex', gap: 24, maxWidth: 600 }}>
              <WxbInput label="Lot No." placeholder="BX-2418-A03" helpText="Format: BX-YYWW-A##" />
              <WxbInput label="Yield (g/L)" defaultValue="0.00" error="Yield must be greater than 0." />
            </div>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>1b. Switch / Toggle</h2>
            <WxbCard>
              <div style={{ display: 'flex', gap: 32, alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>Default</span>
                  <WxbSwitch />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>Checked</span>
                  <WxbSwitch defaultChecked />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>With Label</span>
                  <WxbSwitch checkedChildren="启用" unCheckedChildren="停用" defaultChecked />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>Small</span>
                  <WxbSwitch size="sm" defaultChecked />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>Disabled OFF</span>
                  <WxbSwitch disabled />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  <span className="wxb-body" style={{ fontSize: 12, color: 'var(--wx-fg-3)' }}>Disabled ON</span>
                  <WxbSwitch disabled checked />
                </div>
              </div>
            </WxbCard>
          </section>

          <section style={{ marginBottom: 32 }}>
            <div className="uikit-section-title-row">
              <h2 className="wxb-h4">1c. Modals & Dialogs</h2>
              <WxbStatusBadge label="新增强" tone="cyan" size="sm" />
            </div>
            <WxbCard>
              <div style={{ display: 'flex', gap: 16 }}>
                <WxbButton onClick={() => setShowModal(true)}>打开可调整弹窗</WxbButton>
                <WxbButton variant="danger" onClick={() => setShowConfirm(true)}>打开危险确认</WxbButton>
              </div>
            </WxbCard>

            <WxbModal 
              title="生产窗口调整" 
              open={showModal} 
              onCancel={() => setShowModal(false)}
              onOk={() => setShowModal(false)}
              resizable
              resizeDefaultSize={{ width: 720, height: 520 }}
              resizeLimits={{ minWidth: 420, minHeight: 320, maxWidth: 1040, maxHeight: 760 }}
            >
              <WxbStack gap="lg" className="uikit-modal-demo-body">
                <WxbInline justify="between" fullWidth>
                  <WxbText tone="secondary">
                    新增强：右侧、底部和右下角支持拖拽调整，尺寸会受视口和业务限制约束。
                  </WxbText>
                  <WxbTag color="cyan">420×320 - 1040×760</WxbTag>
                </WxbInline>
                <WxbFormGrid columns={2}>
                  <WxbInput label="批次编号" defaultValue="BAT-2026-001" />
                  <WxbInput label="生产线" defaultValue="USP-2 / DSP-1" />
                  <WxbInput label="计划开始" defaultValue="2026-07-06 08:00" />
                  <WxbInput label="计划结束" defaultValue="2026-07-09 20:00" />
                </WxbFormGrid>
                <WxbValidationSummary
                  hideWhenEmpty={false}
                  title="窗口调整约束"
                  issues={[
                    { field: '最小尺寸', message: '保留表单和底部动作的可读空间。' },
                    { field: '最大尺寸', message: '不超过当前视口，也不超过业务配置上限。' },
                  ]}
                />
              </WxbStack>
            </WxbModal>

            <WxbModal 
              title="Irreversible Action" 
              open={showConfirm} 
              onCancel={() => setShowConfirm(false)}
              onOk={() => setShowConfirm(false)}
              okText="Delete Record"
              okVariant="danger"
              width={400}
            >
              <p className="wxb-body" style={{ margin: '16px 0', color: 'var(--wx-fg-2)' }}>
                Are you sure you want to delete this record? This action cannot be undone.
              </p>
            </WxbModal>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>2. Badges & Alerts</h2>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
              <WxbBadge variant="code" status="success" label="In Spec" />
              <WxbBadge variant="outline" status="warning" code="WRN" label="Near Limit" />
              <WxbBadge variant="tracked" status="error" label="OOS" />
            </div>
            <div style={{ display: 'flex', gap: 16 }}>
              <WxbAlert variant="warning" title="Bioreactor BR-204 approaching lower limit">
                Current 38%, threshold 35%. Consider increasing sparge rate.
              </WxbAlert>
              <WxbAlert variant="error" title="DEV-2026-0418 · OOS detected">
                Yield falls below specification. Investigation required.
              </WxbAlert>
            </div>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>3. Stepper & Table</h2>
            <WxbCard style={{ marginBottom: 24 }}>
              <WxbStepper steps={[
                { label: 'Inoculation', desc: 'D0', status: 'done' },
                { label: 'Seed Train', desc: 'D1-D4', status: 'done' },
                { label: 'Production', desc: 'D5-D11', status: 'curr' },
                { label: 'Harvest', desc: 'D12', status: 'todo' }
              ]} />
            </WxbCard>

            <WxbTableWrapper>
              <thead>
                <tr>
                  <th>Lot</th>
                  <th>Bioreactor</th>
                  <th className="num-cell">Yield</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="mono-cell">BX-2418-A03</td>
                  <td>BR-204</td>
                  <td className="num-cell">5.84 g/L</td>
                  <td><WxbBadge variant="code" status="info" label="QA Review" /></td>
                </tr>
                <tr>
                  <td className="mono-cell">BX-2418-A02</td>
                  <td>BR-204</td>
                  <td className="num-cell">5.62 g/L</td>
                  <td><WxbBadge variant="code" status="success" label="Released" /></td>
                </tr>
              </tbody>
            </WxbTableWrapper>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>4. Chart & KPI</h2>
            <div style={{ display: 'flex', gap: 16 }}>
              <div style={{ flex: 2 }}>
                <WxbChartCard 
                  title="Capacity Utilization" 
                  subtitle="13-week trend · Wuxi MFG8" 
                  data={MOCK_CHART_DATA} 
                />
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 16 }}>
                <WxbKpiCard title="Overall Capacity" value="78" unit="%" trend="up" trendText="4.2 pts WoW" />
                <WxbKpiCard title="Open Deviations" value="3" trend="down" trendText="1 vs last week" />
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 32 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>5. Brand Logo</h2>
            <div style={{ display: 'flex', gap: 24, alignItems: 'center', background: '#fff', padding: 24, borderRadius: 8, border: '1px solid #E4EAF1' }}>
              <WxbLogo width={200} mode="dark" />
              <div style={{ background: '#0B3D7F', padding: '24px 32px', borderRadius: 6 }}>
                <WxbLogo width={200} mode="light" />
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 64 }}>
            <h2 className="wxb-h4" style={{ marginBottom: 16 }}>6. GMP Process Iconography Library</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: 12 }}>
              {Object.keys(WxbIconsData).map((iconName) => (
                <div key={iconName} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, background: '#fff', border: '1px solid #E4EAF1', borderRadius: 8, padding: '12px 6px', transition: 'border-color 200ms', cursor: 'default' }} 
                     onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#1F6FEB'; e.currentTarget.style.color = '#0B3D7F'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(31,111,235,.12)'; }}
                     onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E4EAF1'; e.currentTarget.style.color = 'inherit'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                  <WxbIcon name={iconName as WxbIconName} size={28} />
                  <span style={{ fontSize: 10, fontFamily: "var(--wx-font-mono)", color: '#8898A8', textAlign: 'center', wordBreak: 'break-all' }}>{iconName}</span>
                </div>
              ))}
            </div>
          </section>

      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>7. Form Controls</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="7a. 下拉选择器 Select">
            <WxbSelect label="产品类型" placeholder="请选择..." options={[{ label: '单克隆抗体', value: 'mab' }, { label: '双特异性抗体', value: 'bsab' }, { label: 'ADC', value: 'adc' }]} style={{ width: '100%' }} />
            <div style={{ height: 12 }} />
            <WxbSelect label="多选模式" placeholder="请选择标签..." mode="multiple" options={[{ label: 'GMP', value: 'gmp' }, { label: 'cGMP', value: 'cgmp' }, { label: 'BSL-2', value: 'bsl2' }]} style={{ width: '100%' }} />
          </WxbCard>
          <WxbCard title="7b. 日期 & 时间选择器">
            <WxbDatePicker label="批次开始日期" style={{ width: '100%' }} placeholder="选择日期" />
            <div style={{ height: 12 }} />
            <WxbTimePicker label="换班时间" style={{ width: '100%' }} placeholder="选择时间" />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="7c. 数字输入 & 多行文本">
            <WxbInputNumber label="人员数量" placeholder="输入数量" min={1} max={100} defaultValue={8} style={{ width: '100%' }} />
            <div style={{ height: 12 }} />
            <WxbTextarea label="备注说明" placeholder="输入备注信息..." helpText="最多 500 字" />
          </WxbCard>
          <WxbCard title="7d. 搜索输入框 SearchInput">
            <WxbSearchInput placeholder="搜索员工姓名..." onSearch={(v) => console.log('search:', v)} />
            <div style={{ height: 12 }} />
            <WxbSearchInput placeholder="搜索批次号..." defaultValue="BAT-2026" />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="7e. 复选框 Checkbox">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <WxbCheckbox defaultChecked>已通过 GMP 培训</WxbCheckbox>
              <WxbCheckbox>持有安全证书</WxbCheckbox>
              <WxbCheckbox indeterminate>部分完成（半选态）</WxbCheckbox>
              <WxbCheckbox disabled>已锁定（禁用）</WxbCheckbox>
            </div>
          </WxbCard>
          <WxbCard title="7f. 单选框 Radio">
            <WxbRadioGroup options={[{ label: '白班 (08:00-16:00)', value: 'day' }, { label: '中班 (16:00-00:00)', value: 'mid' }, { label: '夜班 (00:00-08:00)', value: 'night' }]} defaultValue="day" direction="vertical" />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="7g. 滑动条 Slider">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <WxbSlider defaultValue={65} />
              <WxbSlider defaultValue={30} disabled />
            </div>
          </WxbCard>
          <WxbCard title="7h. 文件上传 Upload">
            <WxbUpload accept=".xlsx,.csv" fileList={[{ uid: '1', name: 'template_v3.xlsx', size: 24576, status: 'done' }, { uid: '2', name: 'schedule_fail.csv', size: 8192, status: 'error' }]} />
          </WxbCard>
        </div>

        <WxbCard title="7i. 表单字段 FormField">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <WxbFormField label="员工姓名" required error="此字段必填"><WxbInput placeholder="请输入..." /></WxbFormField>
            <WxbFormField label="工号" helpText="格式: WXB-XXXX"><WxbInput placeholder="WXB-" /></WxbFormField>
          </div>
        </WxbCard>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>8. Data Display</h2>
        <WxbCard title="8a. 数据表格 DataTable">
          <WxbBulkActionBar
            selectedCount={tableSelectedRowKeys.length}
            onClear={() => setTableSelectedRowKeys([])}
            actions={[
              { key: 'export', label: '导出选中', variant: 'secondary', onClick: () => console.log('export selected') },
              {
                key: 'archive',
                label: '批量归档',
                variant: 'danger',
                onClick: () => console.log('archive selected'),
                confirm: { title: `确定归档 ${tableSelectedRowKeys.length} 个批次？` },
              },
            ]}
          />
          <WxbDataTable
            density="compact"
            dataSource={MOCK_TABLE_ROWS}
            columns={[
              { title: '批次号', dataIndex: 'id', key: 'id', sorter: (a: any, b: any) => a.id.localeCompare(b.id) },
              { title: '产品', dataIndex: 'product', key: 'product' },
              { title: '状态', dataIndex: 'status', key: 'status', render: (status: string) => <WxbTag color={status === '已完成' ? 'green' : status === '待排程' ? 'amber' : 'blue'}>{status}</WxbTag> },
              { title: '进度', dataIndex: 'progress', key: 'progress', render: (v: number) => <WxbProgress percent={v} /> },
              {
                title: '操作',
                key: 'actions',
                width: 180,
                render: (_: any, record: UiKitBatchRow) => (
                  <WxbTableActionCell
                    actions={[
                      { key: 'view', label: '查看', onClick: () => console.log('view', record.id) },
                      { key: 'copy', label: '复制', onClick: () => console.log('copy', record.id) },
                      {
                        key: 'delete',
                        label: '删除',
                        variant: 'danger',
                        onClick: () => console.log('delete', record.id),
                        confirm: { title: `确定删除 ${record.id}？` },
                      },
                    ]}
                  />
                ),
              },
            ]}
            rowSelection={{
              selectedRowKeys: tableSelectedRowKeys,
              onChange: setTableSelectedRowKeys,
            }}
            emptyState={{ description: '暂无匹配批次' }}
            pagination={false}
          />
          <WxbDivider label="EMPTY" />
          <WxbDataTable
            density="compact"
            dataSource={[]}
            columns={[
              { title: '批次号', dataIndex: 'id', key: 'id' },
              { title: '产品', dataIndex: 'product', key: 'product' },
              { title: '状态', dataIndex: 'status', key: 'status' },
            ]}
            emptyState={{
              description: '暂无匹配批次',
              action: <WxbButton variant="secondary" size="sm">重置筛选</WxbButton>,
            }}
            pagination={false}
          />
        </WxbCard>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="8b. 标签 Tag">
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              <WxbTag color="blue">蓝色标签</WxbTag>
              <WxbTag color="green">已通过</WxbTag>
              <WxbTag color="amber">待审核</WxbTag>
              <WxbTag color="red">已拒绝</WxbTag>
              <WxbTag color="cyan">信息</WxbTag>
              <WxbTag color="neutral">中性</WxbTag>
              <WxbTag color="blue" closable onClose={() => console.log('close')}>可关闭</WxbTag>
            </div>
          </WxbCard>
          <WxbCard title="8c. 文字提示 & 气泡卡片">
            <div style={{ display: 'flex', gap: 16 }}>
              <WxbTooltip title="这是一段提示文字"><WxbButton variant="secondary">悬停查看 Tooltip</WxbButton></WxbTooltip>
              <WxbPopover title="批次详情" content={<div><p>产品: 贝伐珠单抗</p><p>进度: 67%</p></div>}><WxbButton variant="secondary">悬停查看 Popover</WxbButton></WxbPopover>
            </div>
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="8d. 头像 Avatar">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <WxbAvatar initials="ZY" />
              <WxbAvatar initials="LW" color="#2E9D6E" />
              <WxbAvatar initials="CX" color="#D6493A" size={28} />
              <WxbAvatarGroup max={3}>
                <WxbAvatar initials="A" /><WxbAvatar initials="B" color="#2E9D6E" /><WxbAvatar initials="C" color="#E8B53C" /><WxbAvatar initials="D" color="#D6493A" /><WxbAvatar initials="E" />
              </WxbAvatarGroup>
            </div>
          </WxbCard>
          <WxbCard title="8e. 描述列表 Descriptions">
            <WxbDescriptions bordered columns={2} items={[{ label: '批次号', value: 'BAT-2026-001' }, { label: '产品', value: '贝伐珠单抗' }, { label: '状态', value: '进行中' }, { label: '负责人', value: '张工' }]} />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="8f. 时间线 Timeline">
            <WxbTimeline items={[{ label: '批次创建', time: '2026-04-01 08:00', color: 'green' }, { label: '培养基配制', time: '2026-04-02 09:30', color: 'green' }, { label: '接种进行中', time: '2026-04-03 14:00', color: 'blue' }, { label: '待纯化', time: '计划中', color: 'neutral' }]} />
          </WxbCard>
          <WxbCard title="8g. 列表 List">
            <WxbList header="近期偏差" dataSource={['DEV-001: pH 超出范围 (已关闭)', 'DEV-002: 温度波动 (处理中)', 'DEV-003: 无菌检测异常 (调查中)']} renderItem={(item: string) => <span>{item}</span>} />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="8h. 树形控件 Tree">
            <WxbTree defaultExpandAll treeData={[{ title: '生产部', key: 'prod', children: [{ title: '上游车间', key: 'up', children: [{ title: '发酵组', key: 'ferm' }, { title: '培养组', key: 'cult' }] }, { title: '下游车间', key: 'down', children: [{ title: '纯化组', key: 'purif' }] }] }]} />
          </WxbCard>
          <WxbCard title="8i. 骨架屏 & 空状态">
            <WxbSkeleton avatar rows={2} />
            <WxbDivider label="VS" />
            <WxbEmpty description="暂无排程数据" action={<WxbButton variant="primary">创建排程</WxbButton>} />
          </WxbCard>
        </div>

        <WxbCard title="8j. 分割线 Divider">
          <p style={{ margin: 0, color: '#5A6B7E' }}>段落 A</p>
          <WxbDivider />
          <p style={{ margin: 0, color: '#5A6B7E' }}>段落 B</p>
          <WxbDivider label="OR" />
          <p style={{ margin: 0, color: '#5A6B7E' }}>段落 C &nbsp;<WxbDivider direction="vertical" />&nbsp; 行内分割</p>
        </WxbCard>

      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>9. Navigation</h2>
        <WxbCard title="9a. 标签页 Tabs">
          <WxbTabs items={[{ key: 'overview', label: '概览', children: <p>批次概览内容区域</p> }, { key: 'schedule', label: '排程', children: <p>排程视图内容区域</p> }, { key: 'personnel', label: '人员', children: <p>人员管理内容区域</p> }, { key: 'disabled', label: '已归档', disabled: true }]} />
        </WxbCard>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="9b. 面包屑 Breadcrumb">
            <WxbBreadcrumb items={[{ label: '首页' }, { label: '生产管理' }, { label: '批次列表' }, { label: 'BAT-2026-001' }]} />
          </WxbCard>
          <WxbCard title="9c. 分页器 Pagination">
            <WxbPagination current={paginationPage} total={200} pageSize={10} onChange={setPaginationPage} />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="9d. 分段控制器 Segmented">
            <WxbSegmented options={[{ label: '日视图', value: 'day' }, { label: '周视图', value: 'week' }, { label: '月视图', value: 'month' }]} defaultValue="week" />
            <div style={{ height: 8 }} />
            <WxbSegmented size="sm" options={[{ label: '列表', value: 'list' }, { label: '甘特', value: 'gantt' }, { label: '看板', value: 'kanban' }]} defaultValue="gantt" />
          </WxbCard>
          <WxbCard title="9e. 下拉菜单 Dropdown">
            <WxbDropdown menu={{ items: [{ key: '1', label: '导出 Excel' }, { key: '2', label: '导出 PDF' }, { type: 'divider' as const }, { key: '3', label: '删除', danger: true }] }}>
              <WxbButton variant="secondary">操作菜单 ▾</WxbButton>
            </WxbDropdown>
          </WxbCard>
        </div>

      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>10. Feedback</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="10a. 抽屉 Drawer">
            <WxbButton variant="primary" onClick={() => setShowDrawer(true)}>打开抽屉</WxbButton>
            <WxbDrawer title="批次详情" open={showDrawer} onClose={() => setShowDrawer(false)} width={400}>
              <WxbDescriptions columns={1} items={[{ label: '批次号', value: 'BAT-2026-001' }, { label: '产品', value: '贝伐珠单抗' }, { label: '阶段', value: '纯化' }, { label: '负责人', value: '张工' }]} />
            </WxbDrawer>
          </WxbCard>
          <WxbCard title="10b. 气泡确认框 Popconfirm">
            <WxbPopconfirm title="确认删除此批次？" description="删除后不可恢复" onConfirm={() => wxbToast.success('已删除')}>
              <WxbButton variant="danger">删除批次</WxbButton>
            </WxbPopconfirm>
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          <WxbCard title="10c. 加载动画 Spinner">
            <div style={{ display: 'flex', justifyContent: 'center', gap: 24 }}>
              <WxbSpinner size={24} />
              <WxbSpinner size={36} tip="加载中..." />
            </div>
          </WxbCard>
          <WxbCard title="10d. 进度条 Progress (线性)">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <WxbProgress percent={67} />
              <WxbProgress percent={100} status="success" />
              <WxbProgress percent={45} status="warning" />
              <WxbProgress percent={23} status="error" />
            </div>
          </WxbCard>
          <WxbCard title="10d. Progress (环形)">
            <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <WxbProgress type="circle" percent={72} size={72} />
              <WxbProgress type="circle" percent={100} size={72} status="success" />
            </div>
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="10e. 全局提示 Toast">
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <WxbButton variant="primary" onClick={() => wxbToast.success('操作成功')}>成功</WxbButton>
              <WxbButton variant="secondary" onClick={() => wxbToast.error('操作失败')}>错误</WxbButton>
              <WxbButton variant="secondary" onClick={() => wxbToast.warning('请注意')}>警告</WxbButton>
              <WxbButton variant="ghost" onClick={() => wxbToast.info('提示信息')}>信息</WxbButton>
            </div>
          </WxbCard>
          <WxbCard title="10f. 折叠面板 Collapse">
            <WxbCollapse accordion items={[{ key: '1', label: '上游工艺参数', children: '培养温度: 37°C, pH: 7.0, DO: 40%' }, { key: '2', label: '下游纯化步骤', children: 'Protein A → IEX → SEC → UF/DF' }, { key: '3', label: '质量控制检测', children: 'SEC-HPLC, CE-SDS, icIEF, 残留 HCP' }]} />
          </WxbCard>
        </div>

      </section>

      <section style={{ marginBottom: 64 }}>
        <h2 className="wxb-h4" style={{ marginBottom: 16 }}>11. Data Visualization</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="11a. 柱状图 BarChart">
            <WxbBarChart title="月度批次产量" unit="批" data={[{ label: '1月', value: 12 }, { label: '2月', value: 8 }, { label: '3月', value: 15 }, { label: '4月', value: 11 }, { label: '5月', value: 18 }, { label: '6月', value: 14 }]} />
          </WxbCard>
          <WxbCard title="11b. 饼图/环形图 PieChart">
            <WxbPieChart title="产品线分布" centerLabel="78批" data={[{ label: '单抗', value: 45, color: '#0B3D7F' }, { label: 'ADC', value: 18, color: '#2E9D6E' }, { label: '双抗', value: 10, color: '#E8B53C' }, { label: '其他', value: 5, color: '#8898A8' }]} />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <WxbCard title="11c. 面积图 AreaChart">
            <WxbAreaChart title="产能利用率趋势" unit="%" data={[{ label: 'W1', value: 62 }, { label: 'W2', value: 68 }, { label: 'W3', value: 71 }, { label: 'W4', value: 65 }, { label: 'W5', value: 78 }, { label: 'W6', value: 82 }, { label: 'W7', value: 85 }, { label: 'W8', value: 79 }]} />
          </WxbCard>
          <WxbCard title="11d. 迷你甘特图 MiniGantt">
            <WxbMiniGantt title="批次 BAT-001 工序" totalDuration={72} tasks={[{ id: '1', label: '培养基配制', start: 0, end: 8, color: '#2E9D6E' }, { id: '2', label: '细胞接种', start: 8, end: 12, color: '#1F6FEB' }, { id: '3', label: '发酵培养', start: 12, end: 48, color: '#0B3D7F', progress: 65 }, { id: '4', label: '收获/纯化', start: 48, end: 64, color: '#E8B53C' }, { id: '5', label: '质量检测', start: 64, end: 72, color: '#8898A8' }]} />
          </WxbCard>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          <WxbCard title="11e. 仪表盘 Gauge">
            <div style={{ display: 'flex', justifyContent: 'center', gap: 24 }}>
              <WxbGauge percent={78} title="OEE" label="设备效率" />
              <WxbGauge percent={92} title="良品率" label="质量合格" color="var(--wx-green-500,#2E9D6E)" />
            </div>
          </WxbCard>
          <WxbCard title="11f. 迷你趋势线 Sparkline">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#5A6B7E', width: 80 }}>产量趋势</span>
                <WxbSparkline data={[12, 8, 15, 11, 18, 14, 20]} width={100} height={24} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#5A6B7E', width: 80 }}>偏差数</span>
                <WxbSparkline data={[5, 3, 7, 2, 4, 1, 2]} width={100} height={24} color="var(--wx-red-500,#D6493A)" />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#5A6B7E', width: 80 }}>人员利用</span>
                <WxbSparkline data={[78, 82, 85, 79, 88, 91, 87]} width={100} height={24} color="var(--wx-green-500,#2E9D6E)" />
              </div>
            </div>
          </WxbCard>
          <WxbCard title="已有 ChartCard 回顾">
            <WxbChartCard title="产能趋势" subtitle="W14-W24" data={MOCK_CHART_DATA.slice(0, 6)} />
          </WxbCard>
        </div>
      </section>

      {/* ═══ Section 12: 高性能甘特图 ═══ */}
      <section style={{ marginTop: 32 }}>
        <h4 className="wxb-h3" style={{ marginBottom: 16 }}>12. 高性能甘特图 GanttChart — 拖放系统演示</h4>

        {/* Operation tips */}
        <div style={{
          padding: '10px 16px',
          background: 'rgba(31, 111, 235, 0.06)',
          borderRadius: 8,
          marginBottom: 12,
          fontSize: 12,
          color: '#3A4A5C',
          lineHeight: 1.8,
          border: '1px solid rgba(31, 111, 235, 0.12)',
        }}>
          💡 <strong>操作提示</strong>
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          拖动操作条 → 在绿色窗口内移动（15min 吸附）
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          拖动 Stage/Template 条 → 级联移动子任务
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          Ctrl+Click → 多选 → 批量拖动
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          右键 → 上下文菜单（含共享组操作）
          <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
          ESC → 取消 · Ctrl+Z → 撤销
        </div>

        <WxbGanttChart
          style={{ height: 500 }}
          groups={[
            { id: 'g1', label: '上游工艺', color: '#1F6FEB' },
            { id: 'g1-s1', label: '配料', parentId: 'g1', color: '#5A93F0' },
            { id: 'g1-s2', label: '发酵', parentId: 'g1', color: '#1F6FEB' },
            { id: 'g2', label: '下游工艺', color: '#2E9D6E' },
            { id: 'g2-s1', label: '灌装', parentId: 'g2', color: '#2E9D6E' },
            { id: 'g3', label: '质量检测', color: '#E8B53C' },
          ]}
          tasks={ganttTasks}
          dependencies={[
            { id: 'd1', from: 't1', to: 't2', type: 'FS', lag: 0 },
            { id: 'd2', from: 't2', to: 't3', type: 'FS', lag: 2 },
            { id: 'd3', from: 't3', to: 't4', type: 'FS', lag: 2 },
            { id: 'd4', from: 't5', to: 't6', type: 'FS' },
            { id: 'd5', from: 't6', to: 't7', type: 'FS', lag: 2 },
            { id: 'd6', from: 't8', to: 't9', type: 'FS' },
            { id: 'd7', from: 't9', to: 't10', type: 'FS', lag: 2 },
          ]}
          links={[
            { id: 'l1', taskIds: ['t4', 't7'], label: '共享设备', color: '#722ed1', style: 'dashed' },
          ]}
          onTaskClick={(task: { label: string }) => console.log('Task clicked:', task.label)}
          onTaskDragEnd={(taskId: string, newStart: number, newEnd: number) => {
            const task = ganttTasks.find((t: { id: string }) => t.id === taskId);
            if (!task) return;
            // Window constraint validation
            if (task.windowStart !== undefined && newStart < task.windowStart) {
              setDragLog((prev: string[]) => [`❌ ${task.label}: 超出窗口边界！已回滚`, ...prev.slice(0, 9)]);
              return false;
            }
            if (task.windowEnd !== undefined && newEnd > task.windowEnd) {
              setDragLog((prev: string[]) => [`❌ ${task.label}: 超出窗口边界！已回滚`, ...prev.slice(0, 9)]);
              return false;
            }
            setGanttTasks(prev => prev.map(t =>
              t.id === taskId ? { ...t, start: newStart, end: newEnd } : t
            ));
            const fmtH = (h: number) => `${Math.floor(h / 24)}d ${(h % 24).toFixed(1)}h`;
            setDragLog((prev: string[]) => [`✅ ${task.label}: ${fmtH(newStart)} → ${fmtH(newEnd)}`, ...prev.slice(0, 9)]);
          }}
          onGroupDragEnd={(groupId: string, deltaHours: number, affectedTaskIds: string[]) => {
            setGanttTasks(prev => prev.map(t =>
              affectedTaskIds.includes(t.id)
                ? { ...t, start: t.start + deltaHours, end: t.end + deltaHours }
                : t
            ));
            const sign = deltaHours > 0 ? '+' : '';
            setDragLog((prev: string[]) => [
              `🔗 级联移动 ${affectedTaskIds.length} 个任务 ${sign}${deltaHours.toFixed(1)}h`,
              ...prev.slice(0, 9),
            ]);
          }}
          onTaskEdit={(task: { label: string }) => {
            setDragLog((prev: string[]) => [`✏️ 编辑: ${task.label}`, ...prev.slice(0, 9)]);
          }}
          onTaskDelete={(task: { id: string; label: string }) => {
            setGanttTasks(prev => prev.filter(t => t.id !== task.id));
            setDragLog((prev: string[]) => [`🗑️ 删除: ${task.label}`, ...prev.slice(0, 9)]);
          }}
          onTaskDuplicate={(task) => {
            const duration = task.end - task.start;
            setGanttTasks(prev => [...prev, { ...prev.find(t => t.id === task.id)!, id: `${task.id}-dup-${Date.now()}`, label: `${task.label} (副本)`, start: task.end + 1, end: task.end + 1 + duration }]);
            setDragLog((prev: string[]) => [`📋 复制: ${task.label}`, ...prev.slice(0, 9)]);
          }}
          onContextAction={(key: string, task: { label: string } | null) => {
            setDragLog((prev: string[]) => [`🖱️ 菜单: ${key}${task ? ` → ${task.label}` : ''}`, ...prev.slice(0, 9)]);
          }}
        />

        {/* Drag log panel */}
        {dragLog.length > 0 && (
          <div style={{
            marginTop: 12,
            padding: '12px 16px',
            background: '#FAFCFE',
            borderRadius: 8,
            border: '1px solid #E4EAF1',
            fontSize: 12,
            color: '#5A6B7E',
          }}>
            <div style={{ fontWeight: 600, marginBottom: 6, color: '#0F1B2D' }}>📋 拖放操作日志</div>
            {dragLog.map((log: string, i: number) => (
              <div key={i} style={{ padding: '2px 0', opacity: 1 - i * 0.08 }}>{log}</div>
            ))}
          </div>
        )}
      </section>

    </div>
  );
};

export default UiKitShowcasePage;
